<template>
    <dialog
        ref="dialog"
        class="info-modal"
    >
        <div class="info-modal__card ot-card">
            <img v-if="logo" class="info-modal__card__logo" :src="logo" :alt="title" />
            <div class="info-modal__card__content">
                <h2 v-if="title">{{ title }}</h2>
                <div v-if="description">{{ description }}</div>
            </div>
            <div class="info-modal__card__footer">
                <OtButton
                    class="info-modal__card__footer__close"
                    @click="close"
                    :title="$t('common.action.continue.title')"
                >
                    {{ $t('common.action.continue.text') }}
                </OtButton>
            </div>
        </div>
    </dialog>
</template>

<script lang="ts">
import {
    Component, Prop, Vue,
} from 'vue-property-decorator';
import OtButton from './OtButton.vue';

@Component({
    components: { OtButton },
})
export default class InfoModal extends Vue {

    @Prop() title!: string;

    @Prop() description!: string;

    @Prop() logo!: string;

    $refs!: {
        dialog: HTMLDialogElement;
    };

    open(): void {
        this.$refs.dialog.showModal();
    }

    close(): void {
        this.$refs.dialog.close();
    }

}
</script>

<style lang="scss" scoped>
.info-modal {
    border: none;
    border-radius: var(--ot-spacing-sm);
    padding: 0;
    max-width: 32rem;
    width: calc(100% - var(--ot-spacing-2xl));
    background: var(--ot-color-core-background);
    color: var(--ot-color-core-foreground);

    &::backdrop {
        background: rgba(0, 0, 0, 0.5);
        -webkit-backdrop-filter: blur(
            0.25rem
        ); /* Webkit does not allow vars in pseudo elements */
        transform: translate3d(
            0,
            0,
            0
        ); /* GPU accelerate blur filter on webkit */
        backdrop-filter: blur(0.25rem);
    }

    &__card {
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: var(--ot-spacing-xl);

        &__logo {
            max-width: 10rem;
            max-height: 3rem;
            object-fit: contain;
            margin: var(--ot-spacing-2xl) var(--ot-spacing-2xl) 0;
        }

        &__content {
            padding: 0 var(--ot-spacing-2xl);

            &:first-child {
                margin-top: var(--ot-spacing-2xl);
            }
            display: flex;
            flex-direction: column;
            gap: var(--ot-spacing-2xs);
        }

        &__footer {
            background: var(--ot-color-core-light-background-secondary);
            padding: var(--ot-spacing-2xl);
            border-radius: 0 0 var(--ot-spacing-sm) var(--ot-spacing-sm);

            &__close {
                width: 100%;
            }
        }
    }
}
</style>
